import React from "react";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Container } from "react-bootstrap";
import { jwtDecode } from "jwt-decode";
import { Link } from "react-router-dom";


class Avantages extends React.Component {




    render() {


        return (
            <section>
                <Container >
                    <Row id='AvantageHeader' className="justify-content-md-center">

                        - MES AVANTAGES OFFERTS PAR BTF -

                    </Row>
                    <Row id='AvantageTitle' className="justify-content-md-center">

                        <center>
                            En tant que client du GROUPE BTF, vous bénéficiez<br />
                            d'un accès gratuit à nos plateformes :
                        </center>

                    </Row>
                    <Row>
                        <Col sm={1}>
                        </Col>
                        <Col sm={4}>
                            <div className="avantageContentBlock">
                                <Link to="https://adherents.reducbox.com/login" target="_blank" rel="noreferrer">
                                <Row>
                                    <img src='/assets/images/Image20240827152813.png' alt="reducbox" />
                                </Row>
                                <Row className='avantageContentLegend'>
                                    <center>
                                        Mon CSE externalisé
                                    </center>
                                </Row>
                                <Row className='avantageContentHeader'>
                                    <center>
                                        Plateforme d'avantages
                                        à tarif réduit
                                        pour vos employés
                                    </center>

                                </Row>
                                <Row className='avantageContentDetail'>
                                    <center>
                                        REDUCBOX vous permet de
                                        fidéliser et récompenser vos
                                        salariés en leur donnant accès
                                        à des milliers d'avantages
                                        toute l'année (achats du quotidien, cinémas, parcs,
                                        sorties culturelles, vacances,
                                        bons d'achats, …)
                                    </center>
                                </Row>
                                </Link>
                            </div>
                        </Col>
                        <Col sm={2}> 
                        </Col>
                        <Col sm={4}>
                            <div className="avantageContentBlock">
                            <Link to={"https://reducpro.fr/?token=" + jwtDecode(this.props.JWTToken).ssoreducpro +"&service=sso&pclient=btf&pkclient=1D2y4edYet5ddYZedrg1"} target="_blank" >
                                <Row>
                                    <img src="/assets/images/Design sans titre (67).png" alt="redupro" />
                                </Row>
                                
                                <Row className='avantageContentLegend'>
                                    <center>
                                        J'économise sur mes frais généraux
                                    </center>
                                </Row>
                                <Row className='avantageContentHeader'>
                                    <center>
                                        Votre service externalisé
                                        pour économiser
                                        sur vos achats professionnels
                                    </center>
                                </Row>
                                <Row className='avantageContentDetail'>
                                    <center>
                                        REDUCPRO vous fait
                                        économiser en moyenne 21%
                                        sur vos achats non stratégiques
                                        (téléphonie professionnelle,
                                        équipements de bureau,
                                        véhicules, ressources
                                        humaines, entretien des locaux,
                                        consommables…)
                                    </center>
                                </Row>
                                </Link>
                            </div>
                        </Col>
                        <Col sm={1}>
                        </Col>
                    </Row>
                </Container>
            </section>
        )
    }
}


const mapStateToProps = (state) => {

    return ({
        currentClient: state.authentication.currentClient,
        JWTToken: state.authentication.JWTToken,
        apiUrl: state.server.apiUrl,
    })
}

Avantages.propTypes = {
    dispatch: PropTypes.func,
    location: PropTypes.object,
    currentClient: PropTypes.object,
    JWTToken: PropTypes.string,
    apiUrl: PropTypes.string
};

export default connect(mapStateToProps)(Avantages);
